import httpService from './httpService';
import { IPinWidgetData } from './types/IPinWidgetData';
import { IHomePage } from './types/IHomePage';
import { AnalysisContentModel } from '../../../models/AnalysisContentModel';

export const getHomePage = (): Promise<IHomePage> => {
  let endpoint = httpService.getEndpointURL(`/Home`);
  return httpService.get(endpoint).then((res) => res.data);
};

export const getHomePageBoards = (): Promise<AnalysisContentModel[]> => {
  let endpoint = httpService.getEndpointURL('/Home/boardContent');
  return httpService.get(endpoint).then((res) => {
    let boards = [];
    res.data.forEach((board) => {
      boards.push(new AnalysisContentModel(board));
    })
    return boards;
  });
};

export const pinWidget = (investorId: number, boardId: number, data: IPinWidgetData): Promise<any> => {
  let endpoint = httpService.getEndpointURL(`/Home/pin/${investorId}/content/${boardId}`);
  return httpService
    .post(endpoint, data)
    .then((res) => res.data);
};

export const updatePinnedWidgets = (widgets) => {
  const data = widgets.map((widget) => {
    return {
      id: widget.unpinId,
      pageId: 0,
      contentType: "analysisContent",
      widgetId: widget.widget.id,
      scenarioSectionId: 0,
      objectId: widget.selectedObject.objectId,
      objectPath: widget.selectedObject.objectPath,
      investorObjectId: widget.investorObjectId,
      setup: null,
      nodes: widget.widget.nodes
    }
  });
  let endpoint = httpService.getEndpointURL(`/Home/pinnedContent`);
  return httpService.put(endpoint, data);
}

export const unPinWidget = (pinContentId: number): Promise<any> => {
  let endpoint = httpService.getEndpointURL(`/Home/unpin/${pinContentId}`);
  return httpService
    .delete(endpoint)
    .then((res) => res.data);
};

export const unPinWidgetFromBoard = (investorObjectId: number, widgetId: number, objectPath: string): Promise<any> => {
  let endpoint = httpService.getEndpointURL(`/Home/unpin/${investorObjectId}/${widgetId}/${objectPath}`);
  return httpService
    .delete(endpoint)
    .then((res) => res.data);
};